
/**
 * SEO 配置 - models (Nederlands)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 Fysica-nauwkeurige AI-videogenerator | WeryAI',
        description: "Genereer realistisch, fysica-nauwkeurige AI-video's met OpenAI Sora 2 met gesynchroniseerde audio en multi-shot consistentie.",
        keywords: 'Sora 2, OpenAI Sora, video model, realistische AI video, tekst naar video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Natieve AI-Beeldgenerator | WeryAI',
        description: 'Gebruik WeryAI Image 2 voor verbluffende natieve AI-beeldgeneratie! Vlaggenschipmodel met geavanceerde stijlcontrole. Gratis credits, geen kaart nodig.',
        keywords: 'WeryAI Image 2, natieve AI-beeldgenerator, vlaggenschip AI-beeld, studiokwaliteit AI, WeryAI Image gratis, hoe WeryAI Image 2 gebruiken, WeryAI',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - xAI Beeldgenerator | WeryAI',
        description: 'Gebruik Grok 2 op WeryAI voor creatieve AI-beelden! xAI model met artistieke flexibiliteit en unieke stijlen. Gratis credits, geen kaart nodig.',
        keywords: 'Grok 2, Grok AI, xAI beeldgenerator, AI-kunst, creatieve AI-beelden, Grok 2 gratis, hoe Grok 2 gebruiken, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Afbeeldingsgenerator | WeryAI',
        description: 'Nano Banana 2 aangedreven door Gemini met wereldkennis en realtime zoeken. Genereer feitelijk nauwkeurige, verbluffende afbeeldingen met ultrasnelle snelheid.',
        keywords: 'Nano Banana 2, Google AI, Gemini, beeldgeneratie, tekstweergave, multi-onderwerp consistentie, 4K, WeryAI',
        og_title: 'Nano Banana 2 Beeldgenerator | WeryAI',
        og_description: 'Nano Banana 2 wordt aangedreven door Gemini met diep wereldbegrip en realtime zoeken, en genereert beelden die zowel mooi als feitelijk accuraat zijn.',
        twitter_title: 'Nano Banana 2 Beeldgenerator | WeryAI',
        twitter_description: 'Nano Banana 2 wordt aangedreven door Gemini met diep wereldbegrip en realtime zoeken, en genereert beelden die zowel mooi als feitelijk accuraat zijn.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI-afbeeldingsgenerator',
        twitterImageAlt: 'Nano Banana 2 AI-afbeeldingsgenerator',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo Cinematografische AI Videogenerator | WeryAI',
        description: `Kling 2.5 Turbo maakt hoogwaardige video's met geavanceerde lenscontrole, emotionele expressies en vloeiende fysica.`,
        keywords: 'Kling 2.5 Turbo, Kling AI, cinematografische AI video, lenscontrole AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 Geavanceerde AI-videogenerator | WeryAI',
        description: `Runway Gen-4 genereert realistische, consistente AI-video's met dieper promptbegrip en slimme bewerkingstools. Probeer het gratis op WeryAI.`,
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst naar video, afbeelding naar video, AI-videobewerking, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator Geavanceerde Videocreatie | WeryAI',
        description: `Genereer geavanceerde AI video's met Hailuo AI op WeryAI. Voorzien van state-of-the-art bewegingscontrole en realistische rendering.`,
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bewegingscontrole, realistische video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator Dans en beweging creatie | WeryAI',
        description: 'Seedance AI videogenerator - Dans en beweging creatie on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Regisseursniveau AI-videogenerator | WeryAI',

        description: 'Maak regisseursniveau AI-video\'s met Werydance 2.0: multimodale referenties, narratieve consistentie en fysicasimulatie. Gratis op WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, AI videogenerator, regisseursniveau video, multimodale video, fysicasimulatie, lipsynchronisatie, tekst naar video, gratis AI video, WeryAI',

        og_title: 'Werydance 2.0 - Regisseursniveau AI-videogenerator | WeryAI',

        og_description: 'Maak regisseursniveau AI-video\'s met Werydance 2.0: multimodale referenties, narratieve consistentie en fysicasimulatie. Gratis op WeryAI.',

        twitter_title: 'Werydance 2.0 - Regisseursniveau AI-videogenerator | WeryAI',

        twitter_description: 'Maak regisseursniveau AI-video\'s met Werydance 2.0: multimodale referenties, narratieve consistentie en fysicasimulatie. Gratis op WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - AI-Beeldgenerator | WeryAI',
        description: 'Gebruik Nano Banana Pro op WeryAI voor AI-beelden van hoogste kwaliteit! Concurreert met Midjourney in kwaliteit. Gratis credits, geen kaart nodig.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI-beeld, reasoning AI-beeld, 4K AI-beeld, Nano Banana Pro gratis, hoe Nano Banana Pro gebruiken, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - AI-Beeldgenerator | WeryAI',
        description: 'Gebruik Nano Banana op WeryAI om makkelijk AI-beelden te maken! Veelzijdig en snel AI-beeldmodel. Gratis credits, geen kaart nodig.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI-beeld, snelle AI-generator, karakterconsistentie, Nano Banana gratis, hoe Nano Banana gebruiken, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Probeer AI-Beeldgenerator | WeryAI',
        description: 'Gebruik FLUX op WeryAI voor verbluffende AI-beelden! Gebouwd door het Stable Diffusion-team met uitzonderlijke visuele kwaliteit. Gratis credits, geen kaart nodig.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI-beeldgenerator, tekst naar beeld, AI-kunst, FLUX gratis, hoe FLUX gebruiken, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Pro AI-Beeldeditor | WeryAI',
        description: 'Gebruik FLUX Kontext op WeryAI voor professionele AI-beeldbewerking! Superieure nauwkeurigheid, geavanceerde typografie en meerstaps bewerking. Gratis credits, geen kaart nodig.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI-beeldeditor, professionele AI-beelden, typografie AI, FLUX Kontext gratis, hoe FLUX Kontext gebruiken, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Google AI-Beeldgenerator | WeryAI',
        description: 'Gebruik Google Imagen 4 op WeryAI voor fotorealistische AI-beelden! Veelzijdige stijlcontrole en nauwkeurige tekstgeneratie. Gratis credits, geen kaart nodig.',
        keywords: 'Imagen 4, Google Imagen, Google AI-beeldgenerator, tekst naar beeld, fotorealistische AI, Imagen gratis, hoe Imagen 4 gebruiken, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Alibaba AI-Beeldmodel | WeryAI',
        description: 'Gebruik Qwen Image op WeryAI voor meertalige AI-kunst! Alibaba open-source model met superieure tekstrendering. Gratis credits, geen kaart nodig.',
        keywords: 'Qwen Image, Alibaba AI, open-source AI-beeld, meertalige tekstrendering, Qwen Image gratis, hoe Qwen Image gebruiken, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Alibaba Beeldgenerator | WeryAI',
        description: 'Gebruik Wan AI op WeryAI voor AI-beelden met hoge getrouwheid! Alibaba model met precieze prompt-volging en fotorealistische rendering. Gratis credits, geen kaart nodig.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI-beeldgenerator, tekst naar beeld, fotorealistische AI, Wan AI gratis, hoe Wan AI gebruiken, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Beeld AI | WeryAI',
        description: 'Gebruik Seedream 4.0 op WeryAI voor ultrasnelle AI-beeldgeneratie! ByteDance model met diverse kunststijlen. Gratis credits, geen kaart nodig.',
        keywords: 'Seedream, Seedream 4.0, ByteDance beeld AI, ultrasnelle AI-beeld, artistieke AI-stijlen, Seedream gratis, hoe Seedream gebruiken, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - Multimodaal Beeld AI | WeryAI',
        description: 'Gebruik Dreamina 4.0 op WeryAI voor multimodale AI-beeldcreatie! Schets naar beeld, stijloverdracht en karakterfusie. Gratis credits, geen kaart nodig.',
        keywords: 'Dreamina 4.0, ByteDance beeld AI, multimodaal AI-beeld, schets naar beeld, stijloverdracht, Dreamina gratis, hoe Dreamina 4.0 gebruiken, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Beeld AI | WeryAI',
        description: 'Gebruik Seedream 4.5 op WeryAI voor vlaggenschip AI-beeldgeneratie! Nieuwste ByteDance met precieze typografie. Gratis credits, geen kaart nodig.',
        keywords: 'Seedream 4.5, ByteDance beeld AI, vlaggenschip model, typografie rendering, multi-beeld fusie, Seedream 4.5 gratis, hoe Seedream 4.5 gebruiken, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 ByteDance Ultiem AI | WeryAI',
        description: 'Seedream 5.0 is ByteDances meesterwerk op het gebied van AI-visueel met native 8K-kwaliteit, ultiem semantisch begrip, multi-subject compositie en tekstrendering 2.0. Probeer gratis op WeryAI.',
        keywords: 'Seedream 5.0, AI beeldgeneratie, 8K kwaliteit, semantisch begrip, multi-subject compositie, tekstrendering, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Beeldgenerator | WeryAI',
        og_description: 'Seedream 5.0 is ByteDances meesterwerk op het gebied van AI-visuele generatie met native 8K-kwaliteit, ultiem semantisch begrip, multi-subject compositie en geavanceerde tekstrendering.',
        twitter_title: 'Seedream 5.0 Beeldgenerator | WeryAI',
        twitter_description: 'Seedream 5.0 is ByteDances meesterwerk op het gebied van AI-visuele generatie met native 8K-kwaliteit, ultiem semantisch begrip, multi-subject compositie en geavanceerde tekstrendering.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI-afbeeldingsgenerator',
        twitterImageAlt: 'Seedream 5.0 AI-afbeeldingsgenerator',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Professionele AI Vectorgrafiek Generator | WeryAI',
        description: 'Recraft V4 Vector is een professionele AI vectorgrafiek generator van Recraft.ai die bewerkbare SVG vectoren genereert met verliesvrije schaling, nauwkeurige typografie en merkstijl controle. Probeer gratis op WeryAI nu.',
        keywords: 'Recraft V4 Vector, AI vectorgeneratie, SVG generator, echte vector, logo ontwerp, UI iconen, vectorillustratie, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Probeer AI-Kunstgenerator | WeryAI',
        description: 'Gebruik Midjourney op WeryAI voor artistieke AI-beelden! Bekend om adembenemende esthetiek en lichtkwaliteit. Gratis credits, geen kaart nodig.',
        keywords: 'Midjourney, Midjourney AI, AI-kunstgenerator, artistieke AI-beelden, Midjourney gratis, Midjourney alternatief, hoe Midjourney gebruiken, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator | WeryAI',
        description: 'Maak verbluffende video\'s met Runway Gen-4.5 op WeryAI. Hybride autoregressief-diffusie architectuur voor nauwkeurige fysica simulatie en temporele consistentie.',
        keywords: 'Runway Gen-4.5, AI video generator, filmische AI video, fysica simulatie, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator | WeryAI',
        description: 'Genereer hoge kwaliteit video\'s met Kling 2.6 Pro op WeryAI. Native audiovisuele generatie, filmische 1080p kwaliteit, uitstekende prompt naleving.',
        keywords: 'Kling 2.6 Pro, AI video generator, hoge kwaliteit AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator Precieze camera | WeryAI',
        description: 'Genereer filmische AI video\'s met Dreamina 3.0 (Jimeng 3.0) op WeryAI. Precieze start/eind frame controle, professionele camerabewegingen en 1080p hoog-dynamische video generatie.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, camera controle, start eind frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator Creatieve Video | WeryAI',
        description: 'Laat je creativiteit los op WeryAI met de Kling O1 AI video generator. Perfect voor het genereren van fantasievolle en unieke video-inhoud.',
        keywords: 'Kling O1, AI video generator, creatieve AI video, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Intelligente AI-videogenerator | WeryAI',

        description: 'Maak AI-video\'s met Kling 3.0: intelligent storyboarding, meertalige lipsynchronisatie en nauwkeurige tekstweergave. Gratis op WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI videogenerator, intelligent storyboarding, lipsynchronisatie, tekstweergave, tekst naar video, afbeelding naar video, gratis AI video, WeryAI',

        og_title: 'Kling 3.0 - Intelligente AI-videogenerator | WeryAI',

        og_description: 'Maak AI-video\'s met Kling 3.0: intelligent storyboarding, meertalige lipsynchronisatie en nauwkeurige tekstweergave. Gratis op WeryAI.',

        twitter_title: 'Kling 3.0 - Intelligente AI-videogenerator | WeryAI',

        twitter_description: 'Maak AI-video\'s met Kling 3.0: intelligent storyboarding, meertalige lipsynchronisatie en nauwkeurige tekstweergave. Gratis op WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Natieve 16s audio-video AI-generator | WeryAI',

        description: 'Genereer natieve 16-seconden audio-video met Vidu Q3: slimme montage, nauwkeurige tekstweergave en meertalige lip-sync. Gratis op WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, AI videogenerator, natieve 16s audio-video, intelligent storyboarding, tekstweergave, lipsynchronisatie, tekst naar video, afbeelding naar video, gratis AI video, WeryAI',

        og_title: 'Vidu Q3 - Natieve 16s audio-video AI-generator | WeryAI',

        og_description: 'Genereer natieve 16-seconden audio-video met Vidu Q3: slimme montage, nauwkeurige tekstweergave en meertalige lip-sync. Gratis op WeryAI.',

        twitter_title: 'Vidu Q3 - Natieve 16s audio-video AI-generator | WeryAI',

        twitter_description: 'Genereer natieve 16-seconden audio-video met Vidu Q3: slimme montage, nauwkeurige tekstweergave en meertalige lip-sync. Gratis op WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - OpenAI Beeldgenerator | WeryAI',
        description: 'Gebruik GPT-4o op WeryAI om beelden te maken via gesprek! OpenAI met precieze tekstrendering en hoge kwaliteit. Gratis credits, geen kaart nodig.',
        keywords: 'GPT-4o, GPT-4o beeld, OpenAI beeldgenerator, conversatie AI-kunst, GPT-4o gratis, hoe GPT-4o beelden gebruiken, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - OpenAI Kunstgenerator | WeryAI',
        description: 'Gebruik GPT Image 1.5 op WeryAI voor next-gen AI-kunst! Nieuwste OpenAI model met verbeterde creativiteit. Gratis credits, geen kaart nodig.',
        keywords: 'GPT Image 1.5, OpenAI beeldmodel, AI-kunstgenerator, next-gen AI, GPT Image 1.5 gratis, hoe GPT Image 1.5 gebruiken, WeryAI',
    },
}
